<template>
  <div style="height: 100%">
    <span>{{ category.name }}</span>
  </div>
</template>

<script>
export default {
  name: "topicCategoryHeaderTemplate",
  props: {
    category: {
      type: Object,
      default: null,
    },
  },
  computed: {
  
  },
  methods:{
    
  }
};
</script>
